import { connect } from "react-redux";
import LocationApprovalsList from "./locationApprovalsList";
import { bindActionCreators } from "redux";
import { getApprovalList, acceptApproval, rejectApproval } from "services/redux/approvals/locationApprovals/action"

const mapStateToProps = (state) => ({
  approvalList: state.locationApprovalReducer.approvalList
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getApprovalList,
    acceptApproval,
    rejectApproval
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocationApprovalsList);
